var map = {
	"./a_billing.svg": 3876,
	"./a_briefcase.svg": 681,
	"./a_dashboard.svg": 8193,
	"./a_document.svg": 3404,
	"./a_marketing.svg": 3285,
	"./a_moneys.svg": 9084,
	"./camera.svg": 8854,
	"./in_billing.svg": 7594,
	"./in_briefcase.svg": 9743,
	"./in_dashboard.svg": 3483,
	"./in_document.svg": 974,
	"./in_marketing.svg": 1711,
	"./in_moneys.svg": 5494,
	"./in_setting.svg": 8567,
	"./in_settings.svg": 6022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;